/** Consecutive daily runs with zero valid contacts before auto-archive (Confluence business rule). */
export const ZERO_CONTACT_ARCHIVE_THRESHOLD = 30;

/** Paused workflows archived after this many days — safety net because paused workflows never execute migrateContacts. */
export const PAUSED_ARCHIVE_DAYS = 30;

/** All workflow types (Migration, Transfer, Exile) run daily under unified business rules. */
export const DAILY_CRON_SCHEDULE = '0 0 * * *';
